/* eslint-disable no-case-declarations */
import {
  SET_LOOKAHEAD_RESOURCE_RANGE_FILTERED,
  SET_LOOKAHEAD_ACTIVATED_RESOURCE_COLS,
  NOTIFY_LOOKAHEAD_UPDATE_RESOURCE,
  NOTIFY_LOOKAHEAD_UPDATE_GROUP_RESOURCE,
  NOTIFY_LOOKAHEAD_UPDATE_FILTER_RESOURCE,
  NOTIFY_LOOKAHEAD_UPDATE_ORDER_RESOURCE
} from '../actions/lookaheadResourceActions';

/**
 * Reducer function means a switch case to filter action data on the platform for general state
 * @param {*} state Real time updated through all components state (general state flux)
 * @param {*} action Action is an object with structyure { type: STRING, payload: FUNCTION }
 */
function lookaheadReducer(
  state = {
    activatedColumns: [],
    isRangeDateFiltered: false,
    dateRangeToFilter: [],
    notifyChange: false,
    notifyChangeGroup: false,
    notifyChangeFilter: false,
    notifyChangeOrder: false
  },
  action
) {
  switch (action.type) {
    case SET_LOOKAHEAD_ACTIVATED_RESOURCE_COLS:
      return {
        ...state,
        activatedColumns: action.payload
      };
    case SET_LOOKAHEAD_RESOURCE_RANGE_FILTERED:
      return {
        ...state,
        isRangeDateFiltered: action.payload.boolean,
        dateRangeToFilter: action.payload.dateRange
      };
    case NOTIFY_LOOKAHEAD_UPDATE_RESOURCE:
      return {
        ...state,
        notifyChange: !state.notifyChange
      };
    case NOTIFY_LOOKAHEAD_UPDATE_GROUP_RESOURCE:
      return {
        ...state,
        notifyChangeGroup: !state.notifyChangeGroup
      };
    case NOTIFY_LOOKAHEAD_UPDATE_FILTER_RESOURCE:
      return {
        ...state,
        notifyChangeFilter: !state.notifyChangeFilter
      };
    case NOTIFY_LOOKAHEAD_UPDATE_ORDER_RESOURCE:
      return {
        ...state,
        notifyChangeOrder: !state.notifyChangeOrder
      };
    default:
      return state;
  }
}

export default lookaheadReducer;
